import { Injectable } from '@angular/core';
import { ComponentItem, WebElement } from '../../state-management/model/interfaces/state.model';
import { v4 as uuidv4 } from 'uuid';
import { ButtonActionType, ComponentType, ElementsType } from '../../state-management/model/enums/state.enums';

@Injectable({
  providedIn: 'root'
})
export class ComponentTemplateService {

  constructor() { }

  public createFaqComponent(): { component: ComponentItem, elements: WebElement[] } {
    const elements: WebElement[] = [
      {
        "type": ElementsType.ComponentHeader,
        "value": `Häufig gestellte Fragen`,
        "tag": "h2",
        "id": uuidv4(),
        "styles": null,
        "label": "title"
      },
      {
        "type": ElementsType.ComponentHeader,
        "value": `FAQ`,
        "tag": "span",
        "id": uuidv4(),
        "styles": null,
        "label": "subtitle"
      },
      {
        "type": ElementsType.FaqItems,
        "value": "Hier steht die Frage",
        "tag": "span",
        "id": uuidv4(),
        "styles": null,
        "label": "question",
      },
      {
        "type": ElementsType.FaqItems,
        "value": "Hier steht die Antwort auf die Frage",
        "tag": "span",
        "id": uuidv4(),
        "styles": null,
        "label": "answer",
      },
    ]

    const component: ComponentItem = {
      "id": uuidv4(),
      "type": ComponentType.Faq,
      "order": 1,
      "elements": elements.map(element => element.id)
    }

    return { component, elements };
  }


  public createHeroComponent(): { component: ComponentItem, elements: WebElement[] } {
    const elements: WebElement[] = [
      {
        "type": ElementsType.Text,
        "value": "Überschrift",
        "tag": "h1",
        "id": uuidv4(),
        "styles": null,
        "label": "title"
      },
      {
        "type": ElementsType.Text,
        "value": "Untertitel",
        "tag": "p-large",
        "id": uuidv4(),
        "styles": null,
        "label": "subtitle"
      },
      {
        "type": ElementsType.Button,
        "value": "Jetzt kontaktieren",
        "tag": "mat-flat-button",
        "id": uuidv4(),
        "styles": null,
        "label": "highlight-button",
      },
      {
        "type": ElementsType.Button,
        "value": "Unsere Services",
        "tag": "mat-raised-button",
        "id": uuidv4(),
        "styles": null,
        "label": "secondary-button",
        "buttonConfig": {
          "type": ButtonActionType.ScrollTo as ButtonActionType.ScrollTo,
          "params": {
            "target": "32219a97-a536-43d4-b9b5-748cba013ab2"
          }
        }
      },
      {
        "type": ElementsType.Image,
        "value": null,
        "tag": "img",
        "id": uuidv4(),
        "styles": null,
        "label": "hero-image",
        "options": {
          "altText": "Alternativtext für das Bild"
        }
      }
    ]

    const component: ComponentItem = {
      "id": uuidv4(),
      "type": ComponentType.Hero,
      "order": 1,
      "elements": elements.map(element => element.id)
    }

    return { component, elements };
  }

  public createServiceComponent(index: number = 0): { component: ComponentItem, elements: WebElement[] } {
    const elements: WebElement[] = [
      {
        "type": ElementsType.ComponentHeader,
        "value": `Überschrift des Servicebereichs ${index + 1}`,
        "tag": "h2",
        "id": uuidv4(),
        "styles": null,
        "label": "title"
      },
      {
        "type": ElementsType.ComponentHeader,
        "value": `Untertitel des Servicebereichs ${index + 1}`,
        "tag": "span",
        "id": uuidv4(),
        "styles": null,
        "label": "subtitle"
      },
      {
        "type": ElementsType.ServiceDetails,
        "value": "Kontaktieren Sie uns",
        "tag": "mat-flat-button",
        "id": uuidv4(),
        "styles": null,
        "label": "contactButton",
        "buttonConfig": {
          "type": ButtonActionType.ScrollTo as ButtonActionType.ScrollTo,
          "params": {
            "target": "32219a97-a536-43d4-b9b5-748cba013ab2"
          }
        }
      },
      {
        "type": ElementsType.ServiceDetails,
        "value": "Erklären Sie an dieser Stelle Ihren Kunden, was Sie anbieten",
        "tag": "p",
        "id": uuidv4(),
        "styles": null,
        "label": "text"
      },
      {
        "type": ElementsType.ServiceDetails,
        "value": null,
        "tag": "img",
        "id": uuidv4(),
        "styles": null,
        "label": "image",
        "options": {
          "altText": "Beschreibung des Bildes"
        }
      }
    ]

    const component: ComponentItem = {
      "id": uuidv4(),
      "type": ComponentType.ServiceDetails,
      "order": 1,
      "elements": elements.map(element => element.id)
    }

    return { component, elements };
  }

  public createQuoteComponent(): { component: ComponentItem, elements: WebElement[] } {
    const elements: WebElement[] = [
      {
        "type": ElementsType.Text,
        "value": "\"Das ist ein inspirierendes Zitat, ein Spruch oder eine Kundenstimme\"",
        "tag": "h2",
        "id": uuidv4(),
        "styles": null,
        "label": "quote-text"
      },
      {
        "type": ElementsType.Text,
        "value": "Max Mustermann",
        "tag": "p",
        "id": uuidv4(),
        "styles": null,
        "label": "author"
      }
    ];

    const component: ComponentItem = {
      "id": uuidv4(),
      "type": ComponentType.Quote,
      "order": 1,
      "elements": elements.map(element => element.id)
    };

    return { component, elements };
  }

  public createHighlightBoxComponent(): { component: ComponentItem, elements: WebElement[] } {
    const elements: WebElement[] = [
      {
        "type": ElementsType.Text,
        "value": "Das ist ein Beispieltext für eine Highlight-Box.",
        "tag": "p-large",
        "id": uuidv4(),
        "styles": null,
        "label": "highlight-text"
      },
      {
        "type": ElementsType.Button,
        "value": "Kontaktieren Sie uns",
        "tag": "mat-raised-button",
        "id": uuidv4(),
        "styles": null,
        "label": "button",
        "buttonConfig": {
          "type": ButtonActionType.ExternalLink as ButtonActionType.ExternalLink,
          "params": {
            "url": "www.beispiel.de"
          }
        }
      }
    ];
    const component: ComponentItem = {
      "id": uuidv4(),
      "type": ComponentType.HighlightBox,
      "order": 1,
      "elements": elements.map(element => element.id)
    };
    return { component, elements };
  }

  public createSingleColumnImageButtonComponent(): { component: ComponentItem, elements: WebElement[] } {
    const elements: WebElement[] = [
      {
        "type": ElementsType.ComponentHeader,
        "value": "Das ist ein Titel",
        "tag": "h2",
        "id": uuidv4(),
        "styles": null,
        "label": "title"
      },
      {
        "type": ElementsType.ComponentHeader,
        "value": "Das ist ein Untertitel",
        "tag": "span",
        "id": uuidv4(),
        "styles": null,
        "label": "subtitle"
      },
      {
        "type": ElementsType.BaseSingleColumnImageButton,
        "value": null,
        "tag": "img",
        "id": uuidv4(),
        "styles": null,
        "label": "image",
        "options": {
          "altText": "Alternativtext für das Bild"
        }
      },
      {
        "type": ElementsType.BaseSingleColumnImageButton,
        "value": "Kontaktieren Sie uns",
        "tag": "mat-raised-button",
        "id": uuidv4(),
        "styles": null,
        "label": "button",
        "buttonConfig": {
          "type": ButtonActionType.ExternalLink as ButtonActionType.ExternalLink,
          "params": {
            "url": "www.beispiel.de"
          }
        }
      }
    ];
    const component: ComponentItem = {
      "id": uuidv4(),
      "type": ComponentType.SingleColumnImageButton,
      "order": 1,
      "elements": elements.map(element => element.id)
    };
    return { component, elements };
  }

  
  public createLogoCarouselComponent(): { component: ComponentItem, elements: WebElement[] } {
    const elements: WebElement[] = [
      {
        "type": ElementsType.ComponentHeader,
        "value": "Das ist ein Titel",
        "tag": "h2",
        "id": uuidv4(),
        "styles": null,
        "label": "title"
      },
      {
        "type": ElementsType.ComponentHeader,
        "value": "Das ist ein Untertitel",
        "tag": "span",
        "id": uuidv4(),
        "styles": null,
        "label": "subtitle"
      },
      {
        "type": ElementsType.LogoCarouselConfig,
        "value": null,
        "tag": "carousel",
        "id": uuidv4(),
        "styles": null,
        "label": "carousel",
        "config": {
          "images": []
        }
      }
    ];
    const component: ComponentItem = {
      "id": uuidv4(),
      "type": ComponentType.LogoCarousel,
      "order": 1,
      "elements": elements.map(element => element.id)
    };
    return { component, elements };
  }


  // TO BE TESTED
  public createAboutUsComponent(): { component: ComponentItem, elements: WebElement[] } {
    const elements: WebElement[] = [
      {
        "type": ElementsType.ComponentHeader,
        "value": "Das ist ein Titel",
        "tag": "h2",
        "id": uuidv4(),
        "styles": null,
        "label": "title"
      },
      {
        "type": ElementsType.ComponentHeader,
        "value": "Das ist ein Untertitel",
        "tag": "span",
        "id": uuidv4(),
        "styles": null,
        "label": "subtitle"
      },
      {
        "type": ElementsType.ComponentImageText,
        "value": "Das ist eine Titel",
        "tag": "span",
        "id": uuidv4(),
        "styles": null,
        "label": "title"
      },
      {
        "type": ElementsType.ComponentImageText,
        "value": "Hier steht ein Beschreibungstext für die Karte. Dieser Text kann mehrere Zeilen umfassen. Im besten Fall sollte er in etwa der Höhe des Bildes entsprechen. So wirkt die Karten-Galerie am harmonischsten.",
        "tag": "span",
        "id": uuidv4(),
        "styles": null,
        "label": "description"
      },
      {
        "type": ElementsType.ComponentImageText,
        "value": "",
        "tag": "img",
        "id": uuidv4(),
        "styles": null,
        "label": "image",
        "options": {
          "altText": "Alternativtext für das Bild"
        }
      },
    ];

    const component: ComponentItem = {
      "id": uuidv4(),
      "type": ComponentType.AboutUs,
      "order": 1,
      "elements": elements.map(element => element.id)
    };

    return { component, elements };
  }


  // Konfiguration für verfügbare Komponenten (exkludiert Hero, Navbar, etc.)
  public getAvailableComponents(): Array<{type: ComponentType, label: string, description: string}> {
    return [
      {
        type: ComponentType.Faq,
        label: "FAQ",
        description: "Häufig gestellte Fragen und Antworten"
      },
      // {
      //   type: ComponentType.ContactForm,
      //   label: "Kontaktformular",
      //   description: "Formular für Kundenanfragen"
      // },
      {
        type: ComponentType.Quote,
        label: "Zitat/Kundenstimme",
        description: "Inspirierendes Zitat oder Kundenbewertung"
      },
      {
        type: ComponentType.HighlightBox,
        label: "Highlight-Box",
        description: "Hervorgehobener Text mit Call-to-Action"
      },
      {
        type: ComponentType.SingleColumnImageButton,
        label: "Einspaltige Bild-Button-Kombination",
        description: "Bild mit begleitendem Text und Button"
      },
      {
        type: ComponentType.LogoCarousel,
        label: "Logo-Karussell",
        description: "Drehbare Anzeige von Kundenlogos"
      },
      // {
      //   type: ComponentType.CardsGallery,
      //   label: "Karten-Galerie",
      //   description: "Sammlung von Service-Karten"
      // },
      {
        type: ComponentType.AboutUs,
        label: "Über uns",
        description: "Informationen über das Unternehmen"
      },
      {
        type: ComponentType.ServiceDetails,
        label: "Service Details",
        description: "Detaillierte Servicebeschreibung"
      }
    ];
  }

  // Factory-Methode zum Erstellen von Komponenten basierend auf Typ
  public createComponentByType(type: ComponentType): { component: ComponentItem, elements: WebElement[] } | null {
    switch (type) {
      case ComponentType.Faq:
        return this.createFaqComponent();
      case ComponentType.Quote:
        return this.createQuoteComponent();
      case ComponentType.HighlightBox:
        return this.createHighlightBoxComponent();
      case ComponentType.SingleColumnImageButton:
        return this.createSingleColumnImageButtonComponent();
      case ComponentType.LogoCarousel:
        return this.createLogoCarouselComponent();
      case ComponentType.AboutUs:
        return this.createAboutUsComponent();
      // case ComponentType.CardsGallery:
      //   return this.createCardsGalleryComponent();
      case ComponentType.ServiceDetails:
        return this.createServiceComponent();
      default:
        console.warn(`Komponententyp ${type} wird nicht unterstützt`);
        return null;
    }
  }
}
